var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DropdownList',{attrs:{"mobile_only":this.is_mobile},on:{"on-item-selected":function($event){return _vm.selectedItem($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }